import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/ops/api')

/** 客户（委托方）。字段与 services/ops/internal/customer/customer.go 的 Customer 一一对应。 */
export interface Customer {
  id: number
  tenant_id: number
  code: string
  name: string
  contact: string
  phone: string
  address: string
  /** 授信额度，DECIMAL 金额 */
  credit_limit: number
  status: Status
  created_at: string
  updated_at: string
}

export interface CustomerInput {
  code: string
  name: string
  contact: string
  phone: string
  address: string
  credit_limit: number
  status: Status
}

export interface CustomerQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/ops/internal/customer/customer.go 的 StatusNames 同源两份，改一边必须改另一边 */
export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

/** 下拉里的展示文案：「编码 名称」，取不到回退 #id */
export function customerOption(c: Customer): string {
  return `${c.code} ${c.name}`.trim()
}

export const listCustomers = (q: CustomerQuery): Promise<PageResult<Customer>> =>
  api.get<PageResult<Customer>>('/customers', { ...q })

export const createCustomer = (input: CustomerInput): Promise<Customer> =>
  api.post<Customer>('/customers', input)

export const updateCustomer = (id: number, input: CustomerInput): Promise<Customer> =>
  api.put<Customer>(`/customers/${id}`, input)

export const deleteCustomer = (id: number): Promise<void> => api.del<void>(`/customers/${id}`)

/** 下拉参照用的全量客户：后端 size 上限 200 */
export const listCustomerOptions = (): Promise<Customer[]> =>
  listCustomers({ page: 1, size: 200 }).then((page) => page.list)
